module.exports = __webpack_public_path__ + "static/jay-7e1f33e424d30944b9e87103309ffbda.png";